// Intended as a gradual export of matching dashboard state
import Initialiser from '../../initialiser';
import { cloneDeep } from 'utils/immutable';
import store from '../configureStore';
import _ from 'lodash';

// ACTION TYPES
const UPDATE_REPORT_TYPE = 'UPDATE_REPORT_TYPE';
const REPORT_TYPE = 'REPORT_TYPE';

// SYNC ACTION CREATORS
export function updateReportType(reportType) {
    return { type: UPDATE_REPORT_TYPE, reportType };
}

// ASYNC ACTION CREATORS

// SELECTORS
export function selectMatchingDashboard() {
    return store.getState().matching_dashboard;
}

export function selectReportType() {
    const matchingDashboardState = selectMatchingDashboard();
    return _.get(matchingDashboardState, 'selected_report_type');
}

// REDUCER
export default function reducer(state = Initialiser.initialState.matching_dashboard, action) {
    switch (action.type) {
        case UPDATE_REPORT_TYPE: {
            if (!action?.reportType) {
                return state;
            }
            state.selected_report_type = action.reportType;
            return cloneDeep(state);
        }
        case REPORT_TYPE: {
            return state.selected_report_type;
        }
        default: {
            return state;
        }
    }
}
